// src/componentes/comunes/BotonesPdfTicket.js
// «Compartir PDF» (celular: menú del sistema → WhatsApp con el archivo adjunto)
// y «Descargar PDF». El PDF se arma en el navegador: costo cero.
import React, { useMemo, useState } from 'react';
import { FileDown, Share2 } from 'lucide-react';
import { crearPdfTicket, entregarPdf, prepararLogoPdf, puedeCompartirPdf } from '../../utilidades/pdfTicket';

// compacto: solo íconos (listas como el historial de ventas); el nombre va en aria-label y title.
export const BotonesPdfTicket = ({ datos, nombreArchivo, claseBoton = '', textoCompartir = '', etiqueta = 'PDF', compacto = false }) => {
  const [aviso, setAviso] = useState('');
  const compartible = useMemo(puedeCompartirPdf, []);
  const entregar = async (compartir) => {
    setAviso('');
    try {
      // El logo del gym (si hay) se prepara aquí: sin él, el ticket sale solo con el nombre.
      const logo = await prepararLogoPdf(datos?.gym?.logo);
      const resultado = await entregarPdf(crearPdfTicket(datos, { logo }), nombreArchivo, { compartir, texto: textoCompartir });
      if (resultado === 'descargado') setAviso(`Se descargó ${nombreArchivo}. Para enviarlo, adjúntalo en el chat de WhatsApp.`);
    } catch {
      setAviso('No se pudo generar el PDF. Inténtalo de nuevo.');
    }
  };
  if (compacto) {
    return <>
      {compartible && <button type="button" className={claseBoton} title={`Compartir ${etiqueta}`} aria-label={`Compartir ${etiqueta}`} onClick={() => entregar(true)}><Share2 size={16} aria-hidden="true" /></button>}
      <button type="button" className={claseBoton} title={`Descargar ${etiqueta}`} aria-label={`Descargar ${etiqueta}`} onClick={() => entregar(false)}><FileDown size={16} aria-hidden="true" /></button>
    </>;
  }
  return <>
    {compartible && <button type="button" className={claseBoton} onClick={() => entregar(true)}><Share2 size={16} aria-hidden="true" />Compartir {etiqueta}</button>}
    <button type="button" className={claseBoton} onClick={() => entregar(false)}><FileDown size={16} aria-hidden="true" />Descargar {etiqueta}</button>
    {aviso && <p role="status" className="enviar-comprobante-aviso">{aviso}</p>}
  </>;
};

export default BotonesPdfTicket;
